module.exports = __webpack_public_path__ + "img/wallpaper.52e66b71.png";